// Supabase 客户端配置
export const supabaseDefaultConfig = {
    // 认证配置
    auth: {
        // 自动刷新令牌
        autoRefreshToken: true,
        // 检测会话更新
        detectSessionInUrl: true,
        // 持久化会话
        persistSession: true,
        // 存储键名
        storageKey: 'readsavor-auth-token',
    },
    // 数据库配置
    db: {
        schema: 'public',
    },
    // 全局设置
    global: {
        headers: {
            'X-Client-Info': 'readsavor-web',
        },
    },
};
//# sourceMappingURL=config.js.map